import { useCallback, useState } from 'react';

export type ToastSeverity = 'success' | 'error' | 'info' | 'warning';

export interface Toast {
  severity: ToastSeverity;
  message: string;
}

export interface UseToastResult {
  toast: Toast | null;
  notify: (severity: ToastSeverity, message: string) => void;
  success: (message: string) => void;
  error: (message: string) => void;
  clear: () => void;
}

/** Tiny transient-feedback hook for catalog mutations (paired with a MUI Snackbar). */
export function useToast(): UseToastResult {
  const [toast, setToast] = useState<Toast | null>(null);
  const notify = useCallback((severity: ToastSeverity, message: string) => {
    setToast({ severity, message });
  }, []);
  return {
    toast,
    notify,
    success: useCallback((message: string) => setToast({ severity: 'success', message }), []),
    error: useCallback((message: string) => setToast({ severity: 'error', message }), []),
    clear: useCallback(() => setToast(null), []),
  };
}
